import {FACILITY_RESERVATION_CLASSIFICATION, RESERVATION_STATUS} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'

export interface ReserveAvailableStatusDuration {
    startDate: string
    startTime: string
    endDate: string
    endTime: string
}

export interface DurationRentalFacilityReservation {
    id: number
    status: RESERVATION_STATUS
    occupancyStartDateTime: string
    startDateTime: string
    endDateTime: string
    occupancyEndDateTime: string
    ownerName: Nullable<string>
    title: string
}

export interface DurationRentalOtherFacilityReservation {
    facilityId: number,
    classification: FACILITY_RESERVATION_CLASSIFICATION
    status: RESERVATION_STATUS
    occupancyStartDateTime: string
    startDateTime: string
    endDateTime: string
    occupancyEndDateTime: string
    ownerName: Nullable<string>
    title: string
}

export default class ReserveAvailabilityDuration {
    condominiumCd: string
    facilityId: number
    targetDate: string
    reserveAvailableList: ReserveAvailableStatusDuration[]
    currentReserves: DurationRentalFacilityReservation[]
    otherReserves: DurationRentalOtherFacilityReservation[]

    constructor(
        condominiumCd: string,
        facilityId: number,
        targetDate: string,
        reserveAvailableStatus: ReserveAvailableStatusDuration[],
        currentReserves: DurationRentalFacilityReservation[],
        otherReserves: DurationRentalOtherFacilityReservation[] = [],
    ) {
        this.condominiumCd = condominiumCd
        this.facilityId = facilityId
        this.targetDate = targetDate
        this.reserveAvailableList = reserveAvailableStatus
        this.currentReserves = currentReserves
        this.otherReserves = otherReserves
    }

    static from(json: any): ReserveAvailabilityDuration {
        const currentReserves: DurationRentalFacilityReservation[] =
            json.currentReserves.map((current: any) => {
                const {status, ...rest} = current
                return {
                    ...rest,
                    status: RESERVATION_STATUS.codeToEnumConstants(status),
                }
            })

        let otherReserves: DurationRentalOtherFacilityReservation[] = []
        if (json.otherReserves) {
            otherReserves =
                json.otherReserves.map((other: any) => {
                    const {classification, status, ...rest} = other
                    return {
                        ...rest,
                        classification: FACILITY_RESERVATION_CLASSIFICATION.codeToEnumConstants(classification),
                        status: RESERVATION_STATUS.codeToEnumConstants(status),
                    }
                })
        }

        return new ReserveAvailabilityDuration(
            json.condominiumCd,
            json.facilityId,
            json.targetDate,
            json.reserveAvailableList,
            currentReserves,
            otherReserves,
        )
    }
}
